import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import MDEditor from '@uiw/react-md-editor'
import html2canvas from 'html2canvas'
import { KTColors } from '../Constants/KTColors'
import ImageUpload from '../content/ImageUpload'
import AwsConfig from '../../Config/AwsConfig'
import { Button, Modal } from 'react-bootstrap'
import { jobTypes } from '../Data/StaticData'
const styles = {
	input: {
		width: '190px',
	}
}

export default class JobOptions extends Component {
	constructor(props) {
		super(props)
		this.state = {
			// jobOptions: {
			workingHours: '',
			workingDays: '',
			selectedType: 'Full Time',
			selectedLocation: '',
			selectedMainLocation: '',
			selectedSubLocation: '',
			publishedStartDate: new Date(), // value same as scheduled Date in general options
			publishedEndDate: new Date(), // value same as AutoExpireDate
			locationModalVisible: false,
			selectedWorkType: 'work From Home',
			// }
			jobOptions: {},
			jobApplicationLink: '',
		}
	}
	updateStateData = () => {
		console.log(this.props.isEditContent, 'here is teh====')
		let location = ''

		const { workingHours,
			workingDays,
			jobType,
			jobMainLocation,
			jobSubLocation,
			startDate,

			activeTillDate,
			workType,
			jobApplicationLink } = this.props.jobDetailsAtEdit
		if (this.props.isEditContent && jobMainLocation != null && jobSubLocation != null) {
			location = jobMainLocation + '-->' + jobSubLocation
			console.log(location, 'here is location===========')
		} else {
			location = ''
		}
		//this.setState({ selectedLocation: location })
		console.log(this.props.jobDetailsAtEdit, 'here is the log in updatestateData');
		this.setState({
			workingHours: workingHours,
			workingDays: workingDays,
			selectedType: jobType,
			selectedLocation: location,
			selectedMainLocation: jobMainLocation,
			selectedSubLocation: jobSubLocation,
			publishedStartDate: startDate,
			publishedEndDate: activeTillDate,
			selectedWorkType: workType,
			jobApplicationLink: jobApplicationLink
		})
	}
	// componentDidUpdate = (prevProps, prevState) => {
	// 	// if (!this.props.enableCreateContent) {
	// 	console.log(this.props.jobDetailsAtEdit, 'this is the job options in did update')
	// 	if (prevProps != this.props) {
	// 		console.log("inside DidUpdateeee")
	// 		// this.setState({
	// 		// 	workingHours: this.props.jobDetailsAtEdit.workingHours,
	// 		// 	workingDays: this.props.jobDetailsAtEdit.workingDays,
	// 		// 	selectedLocation: this.props.jobDetailsAtEdit.jobMainLocation + '->' + this.props.jobDetailsAtEdit.jobSubLocation,
	// 		// 	// selectedLocation: [{
	// 		// 	// 	selectedMainLocation: this.props.location.mainLocation,
	// 		// 	// 	selectedSubLocation: this.props.location.subLocations,
	// 		// 	// }
	// 		// 	// ]
	// 		// })

	// 	}
	// 	// }
	// }
	componentDidMount = () => {
		console.log('here is the location in render 3')
		let details = this.state.jobOptions
		console.log(details, 'here is the detailssss')
		details.jobType = this.state.selectedType
		details.workType = this.state.selectedWorkType
		details.publishedStartDate = Math.trunc(this.state.publishedStartDate.getTime() / 1000)
		details.publishedEndDate = Math.trunc(this.state.publishedEndDate.getTime() / 1000)
		// this.props.handleJobOptions(details)
		this.props.updateInParent(`jobType`, this.state.selectedType, 'Job')
		this.props.updateInParent(`workType`, this.state.selectedWorkType, 'Job')
		this.props.updateInParent(`startDate`, Math.trunc(this.state.publishedStartDate.getTime() / 1000), 'Job')
		this.props.updateInParent(`activeTillDate`, Math.trunc(this.state.publishedEndDate.getTime() / 1000), 'Job')

		if (this.props.jobDetailsAtEdit && Object.keys(this.props.jobDetailsAtEdit).length > 0) {
			console.log(this.props.jobDetailsAtEdit, "===================5editContent")
			this.updateStateData()
		}


	}
	changeJobType = (currentType, type) => {
		let details = this.state.jobOptions
		details.jobType = type
		this.setState({ selectedType: type, jobOptions: details })
		// this.props.handleJobOptions(details)

		this.props.updateInParent(`jobType`, type, 'Job')

	}
	handleLocations = (location, level) => {
		const locationData = location ? location : ''
		const levelData = level && level != 'All' ? '->' + level : ''
		const selectedLocation = locationData + levelData
		let details = this.state.jobOptions
		details['jobMainLocation'] = location
		details['jobSubLocation'] = level
		console.log(location, level, selectedLocation, 'handle Locations')
		this.setState({
			selectedLocation: selectedLocation,
			selectedMainLocation: location,
			selectedSubLocation: level,
			jobOptions: details

		})
		// this.props.handleJobOptions(details)

		this.props.updateInParent(`jobMainLocation`, location, 'Job')

		this.props.updateInParent(`jobSubLocation`, level, 'Job')
	}
	setEndDate = (date) => {
		let details = this.state.jobOptions
		details.activeTillDate = Math.trunc(date.getTime() / 1000)
		this.setState({ publishedEndDate: date, jobOptions: details })
		// this.props.handleJobOptions(details)

		this.props.updateInParent(`activeTillDate`, Math.trunc(date.getTime() / 1000), 'Job')
	}
	setStartDate = (date) => {
		let details = this.state.jobOptions
		details.startDate = Math.trunc(date.getTime() / 1000)
		this.setState({ publishedStartDate: date, jobOptions: details })
		// this.props.handleJobOptions(details)

		this.props.updateInParent(`startDate`, Math.trunc(date.getTime() / 1000), 'Job')
	}
	changeWorkType = (currentWorkType, type) => {
		let details = this.state.jobOptions
		details.workType = type
		this.setState({ selectedWorkType: type, jobOptions: details })
		// this.props.handleJobOptions(details)
		this.props.updateInParent(`workType`, type, 'Job')
	}
	handleWorkingDays = (value) => {
		let details = this.state.jobOptions
		details.workingDays = value
		this.setState({ workingDays: value, jobOptions: details })
		// this.props.handleJobOptions(details)
		this.props.updateInParent(`workingDays`, value, 'Job')

	}

	handleWorkingHours = (value) => {
		let details = this.state.jobOptions
		details.workingHours = value
		this.setState({ workingHours: value, jobOptions: details })
		// this.props.handleJobOptions(details)
		this.props.updateInParent(`workingHours`, value, 'Job')

	}
	closeLocationModal = () => {
		this.setState({ locationModalVisible: false })
	}
	renderJobLocations = (locations) => {
		const { selectedLocation } = this.state
		console.log(locations, 'renderJobLocations====')
		return (
			<div>
				<label for='label'>Choose Location : </label>
				<div className='row'>
					{selectedLocation && selectedLocation != 'undefined' ? (
						<div>
							<text for='text'>Selected Locations : </text>
							<text>{selectedLocation}</text>
						</div>
					) : null}
				</div>
				<div>
					{locations?.map((location, locationIndex) => (
						<section class='container' key={locationIndex}>
							{location.mainLocation ? (
								<div key={locationIndex} class='ac'>
									<input
										class='ac-input'
										id={location.mainLocation + locationIndex}
										name={location.mainLocation + locationIndex}
										type='checkbox'
									/>
									<label class='ac-label' for={location.mainLocation + locationIndex}>
										{location.mainLocation}
									</label>
									<article class='ac-text'>
										{location.subLocations &&
											location.subLocations.map((level, levelIndex) => (
												<div key={levelIndex}>
													{

														<label
															onClick={() =>
																this.handleLocations(location.mainLocation, level)
															}
															for={level + location.mainLocation + levelIndex}
														>
															{level}
														</label>
													}
												</div>
											))}
									</article>
								</div>
							) : (
								<label
									onClick={() =>
										this.handleLocations(location.mainLocation, '')
									}
									for={location.mainLocation + locationIndex}
								>
									{location.mainLocation}
								</label>
							)}
						</section>
					))
					}
				</div>
			</div >
		)

	}
	render() {
		console.log(this.props.locations, "here is the location in render 2")
		const { workType, jobTypeOptions, locations } = this.props
		const {
			locationModalVisible,
			selectedType,
			selectedWorkType,
			selectedLocation,
			workingHours,
			workingDays,
			publishedStartDate, // value same as scheduled Date in general options
			publishedEndDate, // value same as AutoExpireDate
		} = this.state
		console.log(selectedLocation, 'renderrrrr==');
		return (
			<div class='row col-md-14'>
				{/* <details> */}
				{/* <summary>Job Options</summary> */}
				<div class='content'>
					<div class='row' style={{ marginBottom: 5 }}>
						<text>Type : </text>
						{jobTypeOptions.map((item, index) => (
							<div className='col-md-4' key={index}>
								<input
									value={selectedType}
									type='radio'
									checked={this.state.selectedType == item}
									onChange={() => {
										this.changeJobType(this.state.selectedType, item)
									}}
								></input>
								<text for={item}>{item}</text>
							</div>
						))}
					</div>
					<div class='row' style={{ marginBottom: 5 }}>
						<text>Work Type : </text>
						{workType.map((item, index) => (
							<div key={index}>
								<input
									value={selectedWorkType}
									type='checkbox'
									checked={this.state.selectedWorkType == item}
									onChange={() => {
										this.changeWorkType(this.state.selectedWorkType, item)
									}}
								></input>
								<text for={item}>{item}</text>
							</div>
						))}
					</div>
					<div class='row' style={{ marginBottom: 5 }}>
						<text>Working Hours Per Day : </text>
						<input style={styles.input}
							type='text'
							onChange={(e) => this.handleWorkingHours(e.target.value)}
							value={workingHours}
						// placeholder='Choose Category'
						></input>
					</div>
					<div class='row' style={{ marginBottom: 5 }}>
						<text>Working Days Per Week : </text>
						<input style={styles.input}
							type='text'
							onChange={(e) => this.handleWorkingDays(e.target.value)}
							value={workingDays}
						// placeholder='Choose Category'
						></input>
					</div>
					<div class='row'>
						<label
							onClick={() => {
								this.setState({ locationModalVisible: true })
							}}
						>
							Location
						</label>
						<input
							type='text'
							onClick={() => {
								this.setState({ locationModalVisible: true })
							}}
							value={selectedLocation}
							placeholder='Choose Location'
						></input>
					</div>


					<Modal show={locationModalVisible} onHide={() => this.closeLocationModal()}>
						<Modal.Body>{this.renderJobLocations(locations)}</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.closeLocationModal()}>Ok</Button>
						</Modal.Footer>
					</Modal>

				</div>
				{/* </details> */}
			</div>
		)


	}
}